module.exports = __webpack_public_path__ + "static/media/company-address-show.b7c475d8.png";